import { render, staticRenderFns } from "./panel-right.vue?vue&type=template&id=59111b1a&scoped=true"
import script from "./panel-right.vue?vue&type=script&lang=js"
export * from "./panel-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59111b1a",
  null
  
)

export default component.exports